import React, { Component } from 'react';
import Radium from 'radium';
import { Route, Switch } from 'react-router-dom'
import Dashboard from './Dashboard';
import HttpServices from "../services/HttpServices";
import UserServices from "../services/UserServices";
import Settings from './Settings';

class LoggedInRoutes extends Component {

	constructor(props) {
		super(props);

		var loggedInUser = null;

		if (window.localStorage.getItem("user") && window.localStorage.getItem("token")) {
			try {
				loggedInUser = JSON.parse(window.localStorage.getItem("user"));
				
				if (!loggedInUser) {
					window.location.href = "/login";
				}

				// See if we have a default saved bubble
				HttpServices.setUserAndToken(loggedInUser, window.localStorage.getItem("token"));
			} catch (e) {
				window.location.href = "/login";
			}
		} else {
			window.location.href = "/login";
		}

		this.state = {
			loggedInUser: loggedInUser,
			token: localStorage.token,
			loading: true
		};
	}

	componentDidMount() {
		if (this.state.loggedInUser) {
			this.loadUserData();
		}
		
	}
	
	async loadUserData() {
		try {
			const userData = await UserServices.loadUserData();

			this.setState({
				subscribed: userData.subscribed,
				bubbles: userData.bubbles,
				loading: false
			});
		} catch (e) {
			this.setState({
				subscribed: false,
				bubbles: null,
				loading: false
			});
		}
	}

	render() {
		if (this.state.loading || !this.state.loggedInUser) {
			// TODO replace with spinner
			return null;
		}

		return (
			<div>
				<Switch>
					<Route path="/settings" exact render={(props) => 
						<Settings {...props} 
							bubbles={this.state.bubbles} 
							subscribed={this.state.subscribed}
							style={this.props.style}
							onReloadUserData={() => this.loadUserData()}/>
						}/>
					<Route path="/" exact render={(props) => 
						<Dashboard {...props} 
							bubbles={this.state.bubbles} 
							subscribed={this.state.subscribed}
							style={this.props.style}/>
						}/>
					
				</Switch>
				
			</div>
			
		);
	}
}


export default Radium(LoggedInRoutes);


// WEBPACK FOOTER //
// ./src/components/LoggedInRoutes.js